<template>
  <div class="container contents shinsei-list">
    <h2>申請一覧</h2>
    <shinsei-list />
  </div>
  <div class="button-container">
    <p class="prev-page">
      <a @click="router.go(-1)">戻る
      </a>
    </p>
  </div>
  <!--contents-->
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import ShinseiSearch from '@/components/shinsei/list/Search.vue'
import { useShinseiStore } from "@/store/shinsei"
import { RouterConst } from "@/const/Router"
import { onBeforeRouteLeave, useRouter } from 'vue-router'

export default defineComponent({
  beforeRouteEnter(to, from, next) {
    const shinseiStore = useShinseiStore();
    if (from.name != RouterConst.SHINSEI_DETAIL) {
      // 検索情報の削除
      shinseiStore.clear();
    }
    next()
  },
  setup() {

    const router = useRouter();
    const shinseiStore = useShinseiStore();
    onBeforeRouteLeave((to, from, next) => {
      if (to.name != RouterConst.SHINSEI_DETAIL) {
        // 検索情報の削除
        shinseiStore.clear();
      }
      next()
    })
    return {
      router
    }
  },
  components: {
    'shinsei-list': ShinseiSearch
  }
})
</script>
